import { render } from "./Home.vue?vue&type=template&id=2b42d468"
const script = {}

import exportComponent from "E:\\VSProjects\\HTML\\quickcalculationpractice\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__